import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  message,
  notification,
  Row,
  Select,
  SelectProps,
  Space,
  Upload,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { AnyObject } from 'antd/es/_util/type';
import Modal from 'antd/es/modal/Modal';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { API } from '../../api';
import CustomerSelect from '../../lib/CustomerSelect';
interface CreateCustomsProps {
  visible: boolean;
  onCancel: any;
  onSuccess: any;
}
export const CreateCustomsModal = ({ visible, onCancel, onSuccess }: CreateCustomsProps) => {
  const [form] = Form.useForm();
  // let currentValue: string;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<SelectProps['options']>([]);
  const [transportData, setTransportData] = useState<SelectProps['options']>([]);
  const [value, setValue] = useState<string>();
  const [file, setFile] = useState<any>(null);
  useEffect(() => {
    if (visible) {
      form?.resetFields();
      setLoading(false);
      setData([]);
      setTransportData([]);
      setFile(null);
    }
  }, [visible]);
  const handleSubmit = async (values: any) => {
    const hasPackages = values.packages && values.packages.length > 0;
    const hasTransports = values.transports && values.transports.length > 0;
    if (!file && !hasPackages && !hasTransports) {
      message.error('Тээвэр, богцны дугаар эсвэл Excel файл сонгоно уу');
      return;
    }
    try {
      setLoading(true);
      if (file) {
        const formData = new FormData();
        formData.append('airBill', values.airBill);
        formData.append('customerNo', values.customerNo.toString());
        if (values.reportType) {
          formData.append('reportType', values.reportType);
        }
        if (values.transportType) {
          formData.append('transportType', values.transportType);
        }
        formData.append('file', file);
        await API.post({ apiVersion: 'api' })(`/customs/create/excel`, formData);
      } else {
        await API.post({ apiVersion: 'api' })(`/customs/create`, values);
      }
      onSuccess();
    } catch (e) {
      notification.error({ message: 'Алдаа', description: 'Алдаа гарлаа' });
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const handleSearch = (newValue: string, customer?: any) => {
    let filter: any = { packageNumber: newValue };
    if (customer) {
      filter = { ...filter, customerNo: customer };
    }
    fetchData(filter, setData);
  };
  const handleTransportSearch = (newValue: string, customer?: any) => {
    let filter: any = { query: newValue };
    if (customer) {
      filter = { ...filter, customerNo: customer };
    }
    fetchTransports(filter, setTransportData);
  };
  const fetchData = (filter: any, callback: (data: { value: string; text: string }[]) => void) => {
    const fake = async () => {
      try {
        //add search params
        const response = await API.get({ apiVersion: 'api' })(
          `/foreign/package/list?customs=false&${queryString.stringify(filter)}`
        );
        const data = response.result.data.map((item: any) => {
          return {
            value: item.packageNumber,
            text: item.packageNumber + (item.shipmentCount ? ` (${item.shipmentCount})` : ''),
          };
        });
        callback(data);
      } catch (e) {
        console.log(e);
      }
    };
    fake();
  };
  const fetchTransports = (
    filter: any,
    callback: (data: { value: string; text: string }[]) => void
  ) => {
    const run = async () => {
      try {
        const response = await API.get({ apiVersion: 'api' })(
          `/foreign/transport/list?page=1&size=50&${queryString.stringify(filter)}`
        );
        const data = (response.result?.data || []).map((item: any) => ({
          value: item.manifestNumber,
          text: `${item.manifestNumber}${
            item.customer?.name ? ` - ${item.customer.name}` : ''
          }${item.packageCount != null ? ` (${item.packageCount} богц)` : ''}`,
        }));
        callback(data);
      } catch (e) {
        console.log(e);
      }
    };
    run();
  };
  const handleChange = (newValue: string) => {
    setValue(newValue);
  };
  const fetchPackagesByTransports = async (manifests: string[]) => {
    if (!manifests || manifests.length === 0) return [];
    try {
      const responses = await Promise.all(
        manifests.map((manifest) =>
          API.get({ apiVersion: 'api' })(
            `/foreign/package/list?page=1&size=1000&manifestNumber=${encodeURIComponent(manifest)}`
          )
        )
      );
      const all: any[] = [];
      responses.forEach((resp: any) => {
        (resp.result?.data || []).forEach((item: any) => all.push(item));
      });
      return all;
    } catch (e) {
      console.log(e);
      return [];
    }
  };
  const handleTransportsChange = async (manifests: string[]) => {
    const items = await fetchPackagesByTransports(manifests);
    const options = items.map((item: any) => ({
      value: item.packageNumber,
      text: item.packageNumber,
    }));
    setData((prev) => {
      const map = new Map<string, { value: string; text: string }>();
      (prev || []).forEach((p: any) => map.set(p.value, p));
      options.forEach((p) => map.set(p.value, p));
      return Array.from(map.values());
    });
    const existing: string[] = form?.getFieldValue('packages') || [];
    const merged = Array.from(new Set([...existing, ...options.map((p) => p.value)]));
    form?.setFieldsValue({ packages: merged });
  };
  return (
    <Modal
      loading={loading}
      title={'Гаалийн мэдүүлэг үүсгэх'}
      open={visible}
      onCancel={onCancel}
      onClose={onCancel}
      onOk={form.submit}
    >
      <Layout.Content>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={15}>
            <Col span={12}>
              <Form.Item
                name={'airBill'}
                label="Тээврийн баримтын дугаар"
                rules={[{ required: true }]}
              >
                <Input placeholder="Тээврийн баримтын дугаар " />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Харилцагч" name={'customerNo'} rules={[{ required: true }]}>
                <CustomerSelect showSearch allowClear />
              </Form.Item>
            </Col>
            {/* <Col span={12}>
              <Form.Item name={'customerNo'} label="Харилцагч" rules={[{ required: true }]}>
                <Select placeholder="Харилцагч">
                  <Select.Option value={900}>YTO Express</Select.Option>
                  <Select.Option value={894}>DPx</Select.Option>
                </Select>
              </Form.Item>
            </Col> */}
            <Col span={12}>
              <Form.Item name={'reportType'} label="Баримтын төрөл">
                <Select placeholder="Баримтын төрөл">
                  <Select.Option value="CN22">CN22</Select.Option>
                  <Select.Option value="CP72">CP72</Select.Option>
                  <Select.Option value="CN23">CN23</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name={'transportType'} label="Тээврийн төрөл">
                {/* <Input placeholder="Тээврийн төрөл" /> */}
                <Select placeholder="Тээврийн төрөл">
                  <Select.Option value="30">Газраар</Select.Option>
                  <Select.Option value="40">Агаар</Select.Option>
                  <Select.Option value="20">Төмөр замаар</Select.Option>
                  <Select.Option value="10">Усан зам</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="Илгээмжийн Excel файл">
            <Space align="center">
              <Upload
                accept=".xlsx, .xls"
                beforeUpload={(file) => {
                  setFile(file);
                  return false;
                }}
                onRemove={() => {
                  setFile(null);
                }}
                fileList={file ? [file] : []}
                maxCount={1}
                showUploadList={false}
              >
                <Button icon={<UploadOutlined />}>Excel файл сонгох</Button>
              </Upload>
              {file ? (
                <span style={{ marginLeft: 8 }}>{file.name}</span>
              ) : (
                <a
                  href="/api/customs/template"
                  target="_blank"
                  rel="noreferrer"
                  style={{ marginLeft: 8 }}
                >
                  Загвар файл татах
                </a>
              )}
            </Space>
          </Form.Item>
          <Form.Item name={'transports'} label="Тээврийн дугаар">
            <Select
              showSearch
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Тээврийн дугаар"
              defaultActiveFirstOption={true}
              suffixIcon={null}
              filterOption={false}
              onFocus={() => handleTransportSearch('', form?.getFieldValue('customerNo'))}
              onSearch={(value) => handleTransportSearch(value, form?.getFieldValue('customerNo'))}
              onChange={(manifests: string[]) => handleTransportsChange(manifests)}
              notFoundContent={null}
              options={(transportData || []).map((d) => ({
                value: d.value,
                label: d.text,
              }))}
            />
          </Form.Item>
          <Form.Item name={'packages'} label="Гадаад богцны дугаар">
            <Select
              showSearch
              mode="multiple"
              style={{ width: '100%' }}
              value={value}
              placeholder="Гадаад богцны дугаар"
              defaultActiveFirstOption={true}
              suffixIcon={null}
              filterOption={false}
              onSearch={(value) => handleSearch(value, form?.getFieldValue('customerNo'))}
              onChange={handleChange}
              notFoundContent={null}
              options={(data || []).map((d) => ({
                value: d.value,
                label: d.text,
              }))}
            />
          </Form.Item>
        </Form>
      </Layout.Content>
    </Modal>
  );
};
